import { render, staticRenderFns } from "./SubjectAddDialog.vue?vue&type=template&id=5a17e303&scoped=true"
import script from "./SubjectAddDialog.vue?vue&type=script&lang=js"
export * from "./SubjectAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17e303",
  null
  
)

export default component.exports